// front/src/components/common/CampoCelular.js
import React from 'react';
import { Form, InputGroup, Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { PAISES, ejemploNacional } from '../../utils/telefono';

/**
 * Campo de celular con selector de país (mismo estilo que los demás inputs).
 *
 * Props:
 *  - pais / onPaisChange       Código ISO del país ('MX', 'EC', ...)
 *  - numero / onNumeroChange   Número sin lada, solo dígitos
 *  - placeholder               Por defecto, un celular de ejemplo del país
 *  - error                     Texto de error (se muestra en rojo debajo)
 *  - onSubmit                  Opcional: muestra el botón → y envía con Enter
 *  - onEnter                   Opcional: acción al presionar Enter, sin mostrar el botón
 *  - disabled                  Opcional
 */
const CampoCelular = ({
  pais,
  onPaisChange,
  numero,
  onNumeroChange,
  placeholder,
  error,
  onSubmit,
  onEnter,
  disabled = false,
}) => {
  const paisActual = PAISES.find((p) => p.iso === pais) || PAISES[0];
  const maxDigitos = ejemploNacional(pais).length || 15;

  // Al cambiar de país se limpia el número, porque cambia su formato
  const cambiarPais = (iso) => {
    onPaisChange(iso);
    onNumeroChange('');
  };

  const cambiarNumero = (e) => {
    onNumeroChange(e.target.value.replace(/\D/g, '').slice(0, maxDigitos));
  };

  const alPresionarTecla = (e) => {
    const accion = onSubmit || onEnter;
    if (accion && e.key === 'Enter') {
      e.preventDefault();
      accion();
      if (onSubmit) e.target.blur();
    }
  };

  return (
    <InputGroup hasValidation>
      <DropdownButton
        variant="outline-secondary"
        title={`${paisActual.bandera} ${paisActual.lada}`}
        onSelect={cambiarPais}
        disabled={disabled}
      >
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {PAISES.map((p) => (
            <Dropdown.Item key={p.iso} eventKey={p.iso} active={p.iso === pais}>
              {p.bandera} {p.nombre} <span className="text-muted">{p.lada}</span>
            </Dropdown.Item>
          ))}
        </div>
      </DropdownButton>

      <Form.Control
        type="tel"
        inputMode="numeric"
        maxLength={maxDigitos}
        placeholder={placeholder ?? ejemploNacional(pais)}
        value={numero}
        onChange={cambiarNumero}
        onKeyDown={alPresionarTecla}
        isInvalid={!!error}
        disabled={disabled}
      />

      {onSubmit && (
        <Button variant="primary" onClick={onSubmit} disabled={disabled}>
          <FaArrowRight />
        </Button>
      )}

      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </InputGroup>
  );
};

export default CampoCelular;
